export const areDatesEqual = (
  date1: Date | null | undefined,
  date2: Date | null | undefined
): boolean => {
  if (date1 == null && date2 == null) return true
  if (date1 == null || date2 == null) return false
  return new Date(date1).getTime() === new Date(date2).getTime()
}
